// src/components/common/Textarea.jsx
import React, { forwardRef } from "react";

/**
 * Textarea with optional char counter
 */
const TextArea = forwardRef(
  (
    {
      label,
      id,
      value,
      onChange,
      placeholder,
      rows = 4,
      maxLength,
      showCounter = true,
      error,
      containerStyle,
      ...rest
    },
    ref
  ) => {
    return (
      <div style={containerStyle ?? { marginBottom: 12 }}>
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {label.replace(" *", "")}
            {label.includes("*") && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          <textarea
            id={id}
            ref={ref}
            className={`textarea-field dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:placeholder-gray-500`}
            rows={rows}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            {...rest}
          />
          <div style={{ position: "absolute", right: 8, bottom: 8 }}>
            {maxLength && showCounter && (
              <small className="text-xs text-gray-500 dark:text-gray-400 bg-white/50 dark:bg-gray-800/50 px-1 rounded">
                {String(value || "").length}/{maxLength}
              </small>
            )}
          </div>
        </div>
        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
